"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// eslint-disable-next-line no-unused-vars
const StyledSelect = (0, _styledComponents.default)(({
  backgroundColor,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_core.Select, props))`
	background-color: ${props => props.backgroundColor};
	min-width: 140px;
	width: ${props => props.$responsive ? '100%' : 'auto'};

	@media (min-width: ${_constants.breakpoints.tablet}) {
		width: auto;
	}

	.MuiSelect-outlined.MuiSelect-outlined {
		padding-right: 54px;
	}
`;
const Wrapper = _styledComponents.default.div`
	min-width: 120px;
	max-width: calc(100%);
	@media (min-width: ${_constants.breakpoints.tablet}) {
		display: inline-block;
	}
`;
const Label = (0, _styledComponents.default)(_core.InputLabel)`
	margin-bottom: 12px;
`;
const HelperText = _styledComponents.default.p`
	font-size: ${_constants.fontSizes.detail2};
	margin: 4px 0 0 0;
	padding: 0;
	color: ${props => props.error ? 'red' : 'black'};
`;
const ExpandMoreIcon = (0, _styledComponents.default)(_ExpandMore.default)`
	width: 26px !important;
`;

const Select = ({
  label,
  error,
  helperText,
  children,
  responsive,
  required,
  ...selectProps
}) => {
  const errorOrHelp = error || helperText;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, label && /*#__PURE__*/_react.default.createElement(Label, {
    required: required
  }, label), /*#__PURE__*/_react.default.createElement(StyledSelect, _extends({
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      getContentAnchorEl: null
    }
  }, selectProps, {
    IconComponent: ExpandMoreIcon,
    $responsive: responsive,
    variant: "outlined",
    error: Boolean(error)
  }), children), errorOrHelp && /*#__PURE__*/_react.default.createElement(HelperText, {
    error: Boolean(error)
  }, errorOrHelp));
};

Select.propTypes = {
  label: _propTypes.default.string,
  error: _propTypes.default.string,
  responsive: _propTypes.default.bool,
  required: _propTypes.default.bool,
  backgroundColor: _propTypes.default.string
};
Select.defaultProps = {
  label: undefined,
  error: '',
  responsive: false,
  required: false,
  backgroundColor: _constants.colours.white
};
var _default = Select;
exports.default = _default;